class columnCaroussel extends HTMLElement {
    constructor() {
      super()
      this.slider = null;
      this.init();
      document.addEventListener("resize", (event) => { 
        this.init();
      });
    }
  
    init() {
      var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if(width < 750){
        this.slider = new Swiper(`.column-slider-${this.dataset.sectionId}`, {
          slidesPerView: parseInt(this.dataset.column),
          spaceBetween: 16,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      }else{
        if(this.slider) this.slider.destroy();
      }
    }
}
if(!customElements.get('column-carousel')){
    customElements.define('column-carousel', columnCaroussel);
}